import { render, staticRenderFns } from "./PGEConfig.vue?vue&type=template&id=2897021f&scoped=true"
import script from "./PGEConfig.vue?vue&type=script&lang=js"
export * from "./PGEConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2897021f",
  null
  
)

export default component.exports